export const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="48px"
    height="48px"
  >
    <path
      fill="#FFC107"
      d="M40,41H8c-2.209,0-4-1.791-4-4V11c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4v26C44,39.209,42.209,41,40,41"
    />
    <path
      fill="#FFF8E1"
      d="M32,16c0,1.657,1.343,3,3,3s3-1.343,3-3s-1.343-3-3-3S32,14.343,32,16"
    />
    <path fill="#D85700" d="M20 16L9 32 31 32z" />
    <path fill="#EF7E03" d="M31 22L23 32 39 32z" />
  </svg>
);
